import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import { EditFilled } from '@ant-design/icons';
import { selectedProduct } from "Store/procurementAtom";
import { useRecoilState } from 'recoil';
import { useHistory } from "react-router-dom";

const Container = styled.div`
    cursor: pointer;
    .anticon{
        color: ${THEME.colors.primary};
        margin-right: 5px;
    }
    label{
        font-weight: bold;
    }
    
`;


function Edit(props) {
    const [product, setSelectedProduct] = useRecoilState(selectedProduct);
    const history = useHistory()

    const onClick = () => {
        if (!product.id) return
        history.push(`/procurement/product-list/new/edit/${product.id}`, { prevPath: '/procurement/product-list'})
    };

    return (
        <Container>
                <EditFilled onClick={onClick} />
                <label>Edit</label>
        </Container>
    )
}

Edit.propTypes = {}

export default Edit